import { selectPreferredName, useAppSelector } from '@core/core/store'
import { sendSpaLogin } from '@core/core/utils'
import { useEffect } from 'react'

/**
 * Посылает логины в СПА.
 * Должно быть использовано только в одном месте
 */
export const useSpaLogin = () => {
  const login = useAppSelector(selectPreferredName)

  useEffect(() => {
    if (login) {
      sendSpaLogin(login)
    }
  }, [login])
}
